$eve_button $eve_flex
	interactive true
	colors? \primary
	variant? \solid
	size? \m
	
	justify_content \center
	align_items \center
	
	sub /
		<= Label $eve_text
			variant \text
			colors? null
			text_variant \bodyMd
			content <= label \
	- mol_button
	enabled true
	click?event null
	event_click?event null
	status? /
	event *
		^
		click?event <=> activate?event <=> event_activate?event null
		dblclick?event <=> clicks?event null
		keydown?event <=> key_press?event <=> event_key_press?event null
	attr *
		^
		disabled <= disabled false
		role \button
		tabindex <= tab_index 0
		title <= hint_safe <= hint \
	Speck $mol_speck
		value <= error \
